import { PropsWithChildren } from "react";
import { IonLabel } from "@ionic/react";
import { Asterisk, Icon } from "swing-components";

import { translate } from "~utils";

type SelectItemProps = PropsWithChildren & {
  id: string;
  label: React.ReactNode | string;
  /** Optional **/
  value?: string;
  stacked?: boolean;
  placeholder?: string;
  className?: string;
  isDisabled?: boolean;
  /**
   * Shows an "*" to the right of the label when `true`
   * @default false
   */
  isRequired?: boolean;
};

/*
 * Wraps IonItem to display a select-type field's modal trigger and selected
 * values. Properly handles placeholder display on no selection and optionally
 * stacks label over displayed value.
 */
export function SelectItem(props: SelectItemProps) {
  const {
    id,
    label,
    value,
    stacked,
    placeholder,
    children,
    className,
    isDisabled = false,
    isRequired = false,
  } = props;

  const Label = () => (
    <IonLabel className="font-medium">
      {label}
      {isRequired && <Asterisk />}
    </IonLabel>
  );

  return (
    <button id={id} disabled={isDisabled} css={{ width: "100%" }}>
      <div className={`flex justify-between items-center ${className}`}>
        {stacked && value ? (
          <>
            <div css={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <Label />
              <div>{value}</div>
            </div>
            {!isDisabled && (
              <div>
                <Icon name="Chevron Down" />
              </div>
            )}
          </>
        ) : (
          <>
            <Label />
            <div className="flex gap-1 items-center">
              <div>{value || <SelectPlaceHolder placeholder={placeholder} />}</div>
              {!isDisabled && (
                <div>
                  <Icon name="Chevron Down" />
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {children}
    </button>
  );
}

const SelectPlaceHolder = ({ placeholder = translate("SELECT_PLACEHOLDER") }) => (
  <span className="swing-select-placeholder">{placeholder}</span>
);
